var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTaskB(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2773.82 2800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d4ecff;}.cls-2{fill:#396caa;}.cls-3{fill:#91b3fa;}.cls-4,.cls-5,.cls-7,.cls-8{fill:#fff;}.cls-4{opacity:0.83;}.cls-4,.cls-5,.cls-8{isolation:isolate;}.cls-5{opacity:0.75;}.cls-6{fill:#699dd1;}.cls-8{opacity:0.78;}.cls-9{fill:url(#linear-gradient);}.cls-10{fill:url(#linear-gradient-2);}.cls-11{fill:url(#linear-gradient-3);}.cls-12{fill:#173d7a;}.cls-13{fill:#274f89;}.cls-14{opacity:0.64;}.cls-15{fill:url(#linear-gradient-4);}.cls-16{fill:url(#linear-gradient-5);}.cls-17{fill:url(#linear-gradient-6);}.cls-18{fill:url(#linear-gradient-7);}.cls-19{fill:url(#linear-gradient-8);}.cls-20{fill:url(#linear-gradient-9);}.cls-21{fill:url(#linear-gradient-10);}.cls-22{fill:url(#linear-gradient-11);}.cls-23{fill:url(#linear-gradient-12);}.cls-24{fill:url(#linear-gradient-13);}.cls-25{fill:url(#linear-gradient-14);}.cls-26{fill:url(#linear-gradient-15);}.cls-27{fill:#7d97f4;}.cls-28{fill:url(#linear-gradient-16);}.cls-29{fill:url(#linear-gradient-17);}.cls-30{fill:url(#linear-gradient-18);}.cls-31{fill:url(#linear-gradient-19);}.cls-32{fill:url(#linear-gradient-20);}.cls-33{fill:#666694;}.cls-34{fill:url(#linear-gradient-21);}.cls-35{fill:url(#linear-gradient-22);}.cls-36{fill:url(#linear-gradient-23);}.cls-37{fill:url(#linear-gradient-24);}.cls-38{fill:url(#linear-gradient-25);}.cls-39{fill:url(#linear-gradient-26);}.cls-40{fill:url(#linear-gradient-27);}.cls-41{fill:url(#linear-gradient-28);}.cls-42{fill:url(#linear-gradient-29);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1520.9,
    y1: 689.58,
    x2: 1739.59,
    y2: 943.42,
    gradientTransform: "matrix(1, 0, 0, -1, -470.08, 3246.97)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff928e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1856.72,
    y1: 1134.27,
    x2: 1210.05,
    y2: 157.32,
    gradientTransform: "matrix(0.71, 0.71, 0.71, -0.71, -165.84, 2201.87)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1837.42,
    y1: 1106.28,
    x2: 1493.08,
    y2: 528.18,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 3710)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1286.17,
    y1: 2656.51,
    x2: 1711.11,
    y2: 1189.45,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 3710)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#febbba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff928e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 1468.33,
    y1: 2709.27,
    x2: 1893.27,
    y2: 1242.23,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 1719.33,
    y1: 2781.98,
    x2: 2144.27,
    y2: 1314.94,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 1877.24,
    y1: 2827.72,
    x2: 2302.18,
    y2: 1360.68,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 1678.84,
    y1: 2770.25,
    x2: 2103.77,
    y2: 1303.21,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 1422.55,
    y1: 2696.01,
    x2: 1847.48,
    y2: 1228.98,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 1120.35,
    y1: 2608.48,
    x2: 1545.29,
    y2: 1141.44,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 1286.33,
    y1: 2656.55,
    x2: 1711.26,
    y2: 1189.52,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 1491.39,
    y1: 2715.95,
    x2: 1916.33,
    y2: 1248.92,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 1564.33,
    y1: 2737.08,
    x2: 1989.26,
    y2: 1270.05,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 1391.02,
    y1: 2686.88,
    x2: 1815.95,
    y2: 1219.84,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 1184.77,
    y1: 2627.14,
    x2: 1609.71,
    y2: 1160.1,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: -6140.03,
    y1: 1841.88,
    x2: -6041.14,
    y2: 1841.88,
    gradientTransform: "matrix(1, 0.05, 0.05, -1, 7031.08, 4224.18)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#09005d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a0f91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: -5737.32,
    y1: 2517.86,
    x2: -5697.21,
    y2: 2517.86,
    gradientTransform: "matrix(0.99, -0.11, -0.11, -0.99, 6982.12, 3893.81)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: -5863.95,
    y1: 2106.19,
    x2: -5708.79,
    y2: 2106.19,
    gradientTransform: "matrix(1, 0.03, 0.03, -1, 6973.67, 4388.61)",
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: -6056.74,
    y1: 1748.4,
    x2: -6016.89,
    y2: 1748.4,
    gradientTransform: "matrix(0.99, 0.14, 0.14, -0.99, 6960.35, 4575.93)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: -5764.83,
    y1: 2866.29,
    x2: -5492.9,
    y2: 2866.29,
    gradientTransform: "matrix(0.99, -0.11, -0.11, -0.99, 6982.12, 3893.81)",
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 1779.1,
    y1: 3737.94,
    x2: 1394.7,
    y2: 3050.05,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 3710)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1473d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9605a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: -5270.4,
    y1: 3680.46,
    x2: -5122.18,
    y2: 3680.46,
    gradientTransform: "matrix(0.99, -0.11, -0.11, -0.99, 6982.12, 3893.81)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 1474.49,
    y1: 2913.91,
    x2: 953.51,
    y2: 2301.89,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 3710)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff928e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: -4934.73,
    y1: 3648.16,
    x2: -5255.04,
    y2: 3249.66,
    gradientTransform: "matrix(0.99, -0.11, -0.11, -0.99, 6982.12, 3893.81)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: -4874,
    y1: 3599.35,
    x2: -5194.32,
    y2: 3200.84,
    gradientTransform: "matrix(0.99, -0.11, -0.11, -0.99, 6982.12, 3893.81)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: -5295.08,
    y1: 3888.97,
    x2: -5605.3,
    y2: 3318.98,
    gradientTransform: "matrix(0.99, -0.11, -0.11, -0.99, 6982.12, 3893.81)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: -2408.96,
    y1: 5172.62,
    x2: -2546.07,
    y2: 4991.25,
    gradientTransform: "matrix(0.75, -0.66, -0.66, -0.75, 6437.05, 3001.65)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: -2513.7,
    y1: 5128.75,
    x2: -2349.9,
    y2: 5128.75,
    gradientTransform: "matrix(0.75, -0.66, -0.66, -0.75, 6437.05, 3001.65)",
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: -2609.77,
    y1: 5028.98,
    x2: -2499.8,
    y2: 5141.8,
    gradientTransform: "matrix(0.75, -0.66, -0.66, -0.75, 6437.05, 3001.65)",
    xlinkHref: "#linear-gradient-4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3125.65,2346.62c-269.12,633.68-986,988.67-1607.67,892.91-101.16-15.58-378.5-62-624-281C421.27,2537,320.18,1702.34,701.48,1114.11,979,686,1476.47,443.3,1949.17,455.43c101.82,2.62,492,18.73,835,301.51,50.37,41.53,161.46,140.23,261.59,296.8C3280.84,1421.41,3301,1933.65,3125.65,2346.62Z",
    transform: "translate(-468.08 -455)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 1871.96,
    cy: 551.48,
    r: 251.46
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 2340.05,
    cy: 1006.48,
    r: 243.1,
    transform: "translate(-494.39 1494.46) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2116,997.13h-.14a2.57,2.57,0,0,1-2.43-2.7,227.49,227.49,0,0,1,3.3-28.51,2.57,2.57,0,0,1,5.06.92,222.74,222.74,0,0,0-3.23,27.86A2.57,2.57,0,0,1,2116,997.13Z",
    transform: "translate(-468.08 -455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M2139.6,908.06a2.56,2.56,0,0,1-2.29-3.73A226,226,0,0,1,2340.05,779.5a228.51,228.51,0,0,1,40.94,3.69,2.57,2.57,0,0,1-.18,5.14,2.69,2.69,0,0,1-.74-.14,223.62,223.62,0,0,0-40-3.6,220.92,220.92,0,0,0-198.16,122A2.58,2.58,0,0,1,2139.6,908.06Z",
    transform: "translate(-468.08 -455)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 1877.27,
    cy: 556.77,
    r: 205.75
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2405.66,930.42c0,36-29.22,75-65.26,75s-65.26-38.91-65.26-75,29.22-61.61,65.26-61.61S2405.66,894.38,2405.66,930.42Z",
    transform: "translate(-468.08 -455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M2259.41,1144.14h159.31a38.57,38.57,0,0,0,36.73-26.81l8.57-26.8a38.53,38.53,0,0,0-23.27-47.93c-64.84-23.7-131.88-20.66-200.55,2.19-19.24,6.4-29.92,27-24.61,46.55l6.6,24.33A38.57,38.57,0,0,0,2259.41,1144.14Z",
    transform: "translate(-468.08 -455)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 1237.34,
    cy: 2532.55,
    r: 257.29
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 1237.34,
    cy: 2532.54,
    r: 248.74
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1500.31,2887a2.75,2.75,0,0,1-2.74-2.76,2.67,2.67,0,0,1,.3-1.24,231.37,231.37,0,0,1,207.55-127.79,234.75,234.75,0,0,1,41.92,3.77,2.74,2.74,0,1,1-.71,5.43l-.29,0a229.31,229.31,0,0,0-40.93-3.68,226,226,0,0,0-202.66,124.78A2.76,2.76,0,0,1,1500.31,2887Z",
    transform: "translate(-468.08 -455)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 1242.76,
    cy: 2537.97,
    r: 210.53
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1690.18,3149.46v-22.9c-23.87-.95-47.49-6.59-64.26-13.93a13.26,13.26,0,0,1-7.33-15.66l5.82-21.33a13.37,13.37,0,0,1,16.43-9.34,12.7,12.7,0,0,1,1.7.6c16.64,7,37.18,12.5,59.34,12.5,23,0,40.14-7.8,40.14-23.78,0-14.42-13.25-23-45.21-31.57-45.6-12.48-78.35-32.36-78.35-72.51,0-36.25,26.51-63.92,72.5-71.33v-22.9a13.35,13.35,0,0,1,13.35-13.35h13.46a13.35,13.35,0,0,1,13.34,13.35v20.56c22.09.89,38.18,4.67,50.94,9.15a13.28,13.28,0,0,1,8.3,16l-5.35,19.73a13.31,13.31,0,0,1-16.3,9.41c-.43-.12-.85-.25-1.27-.41a139.12,139.12,0,0,0-50-9.07c-27.29,0-35.08,11.3-35.08,21.44,0,12.47,16.37,21.05,51.84,32,50.67,15.2,71.72,36.25,71.72,74.06,0,34.69-25.73,65.88-75.62,73.67v25.63a13.34,13.34,0,0,1-13.33,13.35h-13.47A13.35,13.35,0,0,1,1690.18,3149.46Z",
    transform: "translate(-468.08 -455)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 2247.77,
    cy: 2138.43,
    r: 249.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 2247.77,
    cy: 2138.43,
    r: 241.04
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2516.9,2496.34a2.65,2.65,0,0,1-2.65-2.65,2.6,2.6,0,0,1,.28-1.19,224.22,224.22,0,0,1,200.89-124.22,226.77,226.77,0,0,1,40.62,3.57,2.65,2.65,0,1,1-.94,5.22,221.7,221.7,0,0,0-39.67-3.49,218.94,218.94,0,0,0-196.16,121.3A2.65,2.65,0,0,1,2516.9,2496.34Z",
    transform: "translate(-468.08 -455)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 2253.04,
    cy: 2143.69,
    r: 204.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2701.39,2750.38v-22.19c-23.14-.89-46-6.3-62.3-13.39a12.83,12.83,0,0,1-7.13-15.15l5.6-20.69a13,13,0,0,1,16-9,11.66,11.66,0,0,1,1.54.53c16.14,6.73,36.06,12,57.52,12,22.29-.05,38.9-7.63,38.86-23.12,0-14-12.88-22.26-43.87-30.51-44.22-12-76-31.2-76.06-70.11-.07-35.13,25.56-62,70.12-69.26v-22.2a12.94,12.94,0,0,1,12.88-13h13a12.93,12.93,0,0,1,13,12.86v20c21.42.82,37,4.45,49.38,8.77a12.89,12.89,0,0,1,8.08,15.52l-5.15,19.13a12.9,12.9,0,0,1-15.81,9.13c-.4-.11-.8-.23-1.19-.38a134.63,134.63,0,0,0-48.43-8.7c-26.44.05-34,11-34,20.84,0,12.09,15.91,20.37,50.3,30.88,49.13,14.63,69.57,35,69.64,71.63.07,33.62-24.8,63.89-73.14,71.54l.05,24.83a12.93,12.93,0,0,1-12.86,13h-13.05A13,13,0,0,1,2701.39,2750.38Z",
    transform: "translate(-468.08 -455)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 2909.12,
    cy: 1976.09,
    r: 323.4,
    transform: "translate(-1013.33 2180.84) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 2909.12,
    cy: 1976.09,
    r: 312.64,
    transform: "translate(-1013.33 2180.84) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2643.71,1866.49a3.45,3.45,0,0,1-3.38-4.79c43.54-102.08,139.34-169.92,250-177a294.62,294.62,0,0,1,52.87,1.34,3.44,3.44,0,0,1-.79,6.84h0a287.41,287.41,0,0,0-51.64-1.32c-108.07,7-201.61,73.2-244.13,172.88A3.44,3.44,0,0,1,2643.71,1866.49Z",
    transform: "translate(-468.08 -455)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 2916.34,
    cy: 1982.46,
    r: 264.61,
    transform: "translate(-1015.71 2187.82) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2903.07,2180.44l-1.85-28.73c-30,.73-60.11-4.44-81.74-12.29a16.66,16.66,0,0,1-10.45-19l5.58-27.23a16.78,16.78,0,0,1,19.83-13,16.21,16.21,0,0,1,2.17.6c21.43,7.41,47.65,12.67,75.44,10.88,28.84-1.85,49.73-13,48.43-33.06-1.16-18.09-18.47-27.78-59.26-36-58.21-12-100.88-34.26-104.13-84.62-2.92-45.47,28.09-82.32,85.18-95.32l-1.85-28.74a16.77,16.77,0,0,1,15.66-17.81h0L2913,1795a16.77,16.77,0,0,1,17.81,15.66l1.66,25.8c27.79-.68,48.27,2.76,64.64,7.36a16.7,16.7,0,0,1,11.7,19.44l-5.12,25.18a16.73,16.73,0,0,1-19.7,13.1c-.55-.11-1.08-.25-1.61-.41a174.62,174.62,0,0,0-63.4-7.34c-34.22,2.2-43.09,17-42.27,29.72,1,15.64,22.23,25.08,67.61,35.91,64.78,15,92.88,39.67,95.94,87.1,2.8,43.51-27,84.71-88.9,98.51l2.07,32.15a16.78,16.78,0,0,1-15.67,17.82l-16.88,1.09A16.77,16.77,0,0,1,2903.07,2180.44Z",
    transform: "translate(-468.08 -455)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 1280.95,
    cy: 2294.27,
    r: 163.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 1737.55,
    cy: 2755.76,
    r: 157.62,
    transform: "translate(-1907.78 1580.78) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1607.58,2692a1.75,1.75,0,0,1-.78-.18,1.73,1.73,0,0,1-.77-2.32h0a147.47,147.47,0,0,1,158.08-78.59,1.73,1.73,0,0,1-.62,3.41h0a145.57,145.57,0,0,0-25.94-2.33,143.18,143.18,0,0,0-128.42,79.07A1.75,1.75,0,0,1,1607.58,2692Z",
    transform: "translate(-468.08 -455)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 1740.99,
    cy: 2759.18,
    r: 133.41,
    transform: "translate(-1909.19 1584.22) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1727.9,2858.36v-14.52c-15.13-.6-30.1-4.17-40.73-8.83a8.4,8.4,0,0,1-4.64-9.92l3.69-13.51a8.46,8.46,0,0,1,10.4-5.92,8.8,8.8,0,0,1,1.09.38,98.25,98.25,0,0,0,37.6,7.92c14.57,0,25.44-4.95,25.44-15.07,0-9.14-8.4-14.58-28.65-20-28.9-7.9-49.65-20.5-49.65-45.94,0-23,16.8-40.51,45.94-45.2v-14.52a8.46,8.46,0,0,1,8.46-8.46h8.53a8.45,8.45,0,0,1,8.45,8.45h0v13a107.9,107.9,0,0,1,32.28,5.8,8.42,8.42,0,0,1,5.26,10.16l-3.39,12.5a8.43,8.43,0,0,1-10.35,5.95,7.83,7.83,0,0,1-.78-.25,87.81,87.81,0,0,0-31.66-5.75c-17.29,0-22.23,7.16-22.23,13.58,0,7.91,10.37,13.34,32.85,20.26,32.11,9.63,45.45,23,45.45,46.93,0,22-16.3,41.74-47.92,46.68v16.25a8.45,8.45,0,0,1-8.45,8.45h-8.54A8.45,8.45,0,0,1,1727.9,2858.36Z",
    transform: "translate(-468.08 -455)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 1872.89,
    cy: 2532.55,
    r: 209.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 1872.89,
    cy: 2532.55,
    r: 202.24
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2179.87,2895.09a2.22,2.22,0,0,1-2.09-2.33,2.18,2.18,0,0,1,.32-1A188.11,188.11,0,0,1,2353.24,2799a190.3,190.3,0,0,1,33.81,5.27,2.23,2.23,0,0,1-1.08,4.32,186.83,186.83,0,0,0-33-5.15A183.69,183.69,0,0,0,2182,2894,2.2,2.2,0,0,1,2179.87,2895.09Z",
    transform: "translate(-468.08 -455)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 1877,
    cy: 2537.22,
    r: 171.17
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M2320.05,3118.11l1.21-18.58c-19.32-2-38.18-7.86-51.4-14.7a10.75,10.75,0,0,1-5.12-13.08l5.85-17a10.85,10.85,0,0,1,13.82-6.7,11.36,11.36,0,0,1,1.35.57c13.13,6.54,29.51,12.1,47.48,13.27,18.66,1.22,33-4.21,33.83-17.17.77-11.7-9.53-19.36-35-28-36.35-12.53-61.87-30.39-59.74-63,1.91-29.41,24.88-50.47,62.59-54l1.21-18.59a10.85,10.85,0,0,1,11.53-10.12l10.92.71a10.85,10.85,0,0,1,10.12,11.53l-1.08,16.69c17.88,1.88,30.72,5.8,40.84,10.11a10.79,10.79,0,0,1,5.89,13.44L2409,2939.2a10.82,10.82,0,0,1-13.72,6.77c-.35-.12-.68-.25-1-.4a112.84,112.84,0,0,0-40.06-10c-22.14-1.44-29.06,7.31-29.6,15.54-.65,10.12,12.17,17.94,40.38,28.67,40.31,15,56.28,33.2,54.28,63.88-1.83,28.14-24.35,52.09-65.25,55.78l-1.35,20.8a10.85,10.85,0,0,1-11.53,10.12l-10.92-.71a10.86,10.86,0,0,1-10.17-11.51Z",
    transform: "translate(-468.08 -455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2157.75,2408.72h-998.7C963.54,2011,768,1605.29,572.51,1203.57H2744.28C2548.77,1605.29,2353.26,2011,2157.75,2408.72Z",
    transform: "translate(-468.08 -455)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 36.62,
    y: 700.36,
    width: 2309.88,
    height: 88.38,
    rx: 25.23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M2086,2878.73H1230.76c-24.79-148.63-49.58-313.34-74.37-470h1004C2135.62,2565.39,2110.83,2730.1,2086,2878.73Z",
    transform: "translate(-468.08 -455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M2111.58,2882.65c0,17.33-10.7,28.22-23.3,28.22H1222c-12.6,0-22.28-10.89-22.28-28.22v-19.31c0-17.33,9.68-32.81,22.28-32.81h866.32c12.6,0,23.3,15.48,23.3,32.81Z",
    transform: "translate(-468.08 -455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1104.23,2207.62a7.1,7.1,0,0,1-6.51-4.26L717,1331.34a7.1,7.1,0,0,1,13-5.69l380.74,872a7.09,7.09,0,0,1-6.5,9.95Z",
    transform: "translate(-468.08 -455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1245.54,2773.72a7.11,7.11,0,0,1-7-6.23l-36-289.77a7.1,7.1,0,1,1,14.1-1.75l36,289.77a7.1,7.1,0,0,1-6.18,7.93C1246.15,2773.7,1245.85,2773.72,1245.54,2773.72Z",
    transform: "translate(-468.08 -455)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1602.11,2143.61a8.41,8.41,0,0,1-6.55-3.1c-2.87-3.53-5.74-7.2-8.51-10.9a8.43,8.43,0,0,1,13.5-10.1h0c2.63,3.51,5.35,7,8.09,10.35a8.43,8.43,0,0,1-6.53,13.75Z",
    transform: "translate(-468.08 -455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M1569.29,2094.93a8.43,8.43,0,0,1-7.4-4.37c-4.56-8.3-8.83-16.93-12.69-25.62a8.43,8.43,0,1,1,15.42-6.83c3.66,8.26,7.71,16.44,12.05,24.33a8.43,8.43,0,0,1-7.38,12.49Zm-27.85-67.53a8.43,8.43,0,0,1-8.1-6.1c-2.63-9.13-4.9-18.48-6.74-27.79a8.43,8.43,0,1,1,16.54-3.27h0c1.75,8.84,3.9,17.72,6.4,26.39a8.43,8.43,0,0,1-5.76,10.44h0a8.43,8.43,0,0,1-2.34.33Zm-12.26-72a8.42,8.42,0,0,1-8.41-8c-.35-6.16-.52-12.42-.52-18.6,0-3.33,0-6.67.15-10a8.43,8.43,0,0,1,16.86.23c0,.09,0,.19,0,.28-.09,3.17-.13,6.34-.14,9.51,0,5.87.16,11.81.49,17.66a8.43,8.43,0,0,1-7.94,8.89Zm4.17-72.94a7.61,7.61,0,0,1-1.43-.13,8.42,8.42,0,0,1-6.88-9.72h0c1.6-9.35,3.63-18.75,6-27.95a8.43,8.43,0,0,1,16.32,4.25c-2.28,8.74-4.21,17.67-5.73,26.55a8.42,8.42,0,0,1-8.28,7Zm20.29-70.17a8.53,8.53,0,0,1-3.23-.64,8.44,8.44,0,0,1-4.56-11c3.64-8.76,7.7-17.48,12.07-25.92a8.44,8.44,0,0,1,15,7.76h0c-4.15,8-8,16.3-11.46,24.62a8.46,8.46,0,0,1-7.82,5.17Zm35.31-63.93a8.43,8.43,0,0,1-6.87-13.29h0c5.48-7.74,11.36-15.34,17.49-22.6a8.43,8.43,0,1,1,13.17,10.52c-.09.12-.19.24-.29.35-5.82,6.9-11.41,14.12-16.61,21.47a8.45,8.45,0,0,1-6.85,3.55Zm48.6-54.49a8.43,8.43,0,0,1-5.63-14.71c7.08-6.34,14.52-12.45,22.1-18.14a8.43,8.43,0,1,1,10.41,13.26l-.29.22c-7.19,5.41-14.25,11.2-21,17.22a8.42,8.42,0,0,1-5.59,2.14Zm59.54-42.27a8.43,8.43,0,0,1-4.08-15.81c8.29-4.58,16.9-8.86,25.59-12.74a8.44,8.44,0,0,1,6.87,15.41c-8.26,3.67-16.44,7.74-24.31,12.09a8.52,8.52,0,0,1-4.07,1Zm67.46-28a8.43,8.43,0,0,1-2.35-16.53c9.14-2.65,18.48-4.94,27.78-6.8a8.43,8.43,0,1,1,3.65,16.46l-.35.07c-8.83,1.77-17.7,3.94-26.38,6.46a8.13,8.13,0,0,1-2.35.37Zm72-12.4a8.43,8.43,0,0,1-.48-16.85c6.38-.37,12.84-.56,19.19-.56h.09c3.11,0,6.21,0,9.32.13a8.43,8.43,0,0,1-.48,16.86q-4.41-.13-8.85-.13h-.08c-6,0-12.15.18-18.21.53Z",
    transform: "translate(-468.08 -455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M1922.87,1617.79a8.69,8.69,0,0,1-1.76-.18c-4.31-.92-8.65-1.75-12.9-2.47a8.43,8.43,0,0,1,2.82-16.62q6.72,1.14,13.58,2.59a8.43,8.43,0,0,1-1.74,16.68Z",
    transform: "translate(-468.08 -455)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M2132.37,1764.4a8.42,8.42,0,0,1-7.16-4c-2.34-3.75-4.75-7.45-7.17-11a8.43,8.43,0,1,1,13.79-9.7c0,.06.09.12.13.19,2.56,3.74,5.1,7.64,7.56,11.59a8.42,8.42,0,0,1-7.15,12.89Z",
    transform: "translate(-468.08 -455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1855.28,2263.9c-8.5,0-17.1-.33-25.57-1a8.43,8.43,0,1,1,1.16-16.82h.13c8,.62,16.21.93,24.27.93h2.49a8.43,8.43,0,1,1,.07,16.86h0Zm46.89-3.41a8.43,8.43,0,0,1-1.21-16.77c8.76-1.28,17.59-3,26.25-5a8.43,8.43,0,0,1,3.83,16.42h0c-9.12,2.13-18.42,3.89-27.64,5.24A8.52,8.52,0,0,1,1902.17,2260.49Zm69.56-18.14a8.43,8.43,0,0,1-3-16.31c8.29-3.16,16.55-6.7,24.54-10.53a8.43,8.43,0,1,1,7.54,15.08l-.25.12c-8.4,4-17.1,7.76-25.83,11.09A8.31,8.31,0,0,1,1971.73,2242.35Zm63.94-32.78a8.44,8.44,0,0,1-4.66-15.47c7.39-4.88,14.67-10.15,21.63-15.66a8.43,8.43,0,0,1,10.46,13.23h0c-7.33,5.8-15,11.35-22.79,16.5a8.43,8.43,0,0,1-4.64,1.4Zm55.15-46a8.44,8.44,0,0,1-6.08-14.27c6.12-6.39,12.07-13.13,17.66-20a8.43,8.43,0,1,1,13.44,10.19c-.11.14-.22.28-.34.41-5.88,7.28-12.14,14.38-18.59,21.1a8.41,8.41,0,0,1-6.09,2.54Zm43.72-57a8.44,8.44,0,0,1-7.21-12.8c4.59-7.58,8.92-15.46,12.87-23.42a8.43,8.43,0,1,1,15.1,7.5h0c-4.15,8.38-8.71,16.67-13.54,24.65a8.43,8.43,0,0,1-7.22,4Zm30.27-65.18a8.53,8.53,0,0,1-2.7-.44,8.43,8.43,0,0,1-5.29-10.68h0c2.84-8.42,5.35-17,7.46-25.65a8.43,8.43,0,0,1,16.38,4c-2.23,9.06-4.88,18.15-7.86,27a8.43,8.43,0,0,1-8,5.74Zm15.33-70.22a8.65,8.65,0,0,1-.88-.05,8.43,8.43,0,0,1-7.51-9.26h0c.93-8.83,1.49-17.8,1.66-26.66a8.54,8.54,0,0,1,8.59-8.26,8.43,8.43,0,0,1,8.27,8.59h0c-.18,9.33-.77,18.78-1.75,28.09a8.43,8.43,0,0,1-8.38,7.51Zm-.49-71.89a8.42,8.42,0,0,1-8.36-7.44c-1.05-8.81-2.48-17.69-4.26-26.38a8.43,8.43,0,0,1,16.52-3.38h0c1.87,9.15,3.38,18.5,4.48,27.78a8.43,8.43,0,0,1-7.4,9.36,8.06,8.06,0,0,1-1,.06Zm-16.24-70a8.42,8.42,0,0,1-7.95-5.64c-2.95-8.4-6.27-16.76-9.88-24.84a8.43,8.43,0,0,1,15.28-7.13c0,.08.07.17.11.25,3.8,8.51,7.3,17.3,10.4,26.14a8.44,8.44,0,0,1-5.21,10.75,8.56,8.56,0,0,1-2.79.47Z",
    transform: "translate(-468.08 -455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1786.11,2256.45a7.85,7.85,0,0,1-1.81-.2c-4.53-1-9.06-2.07-13.44-3.22a8.43,8.43,0,1,1,4.18-16.33l.09,0c4.16,1.09,8.45,2.12,12.77,3.06a8.43,8.43,0,0,1-1.79,16.67Z",
    transform: "translate(-468.08 -455)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1762,2161.7a3.92,3.92,0,0,0,4.51-.6l34.87-32.53a207.59,207.59,0,0,0,67,6.42l28.07,38.54a3.91,3.91,0,0,0,4.31,1.44l54.7-16.77a3.92,3.92,0,0,0,2.77-3.61l1.65-47.64a207.44,207.44,0,0,0,51.9-42.87l47.12,7.41a3.93,3.93,0,0,0,4.07-2L2089.8,2019a3.92,3.92,0,0,0-.6-4.51l-32.54-34.88a207.3,207.3,0,0,0,6.43-67l38.54-28.06a3.91,3.91,0,0,0,1.44-4.31l-16.77-54.71a3.9,3.9,0,0,0-3.61-2.76L2035,1821a208.23,208.23,0,0,0-42.87-51.9l7.41-47.12a3.92,3.92,0,0,0-2-4.07l-50.54-26.8a3.91,3.91,0,0,0-4.51.59l-34.88,32.54a207.88,207.88,0,0,0-67-6.43l-28.06-38.53a3.93,3.93,0,0,0-4.32-1.44l-54.7,16.77a3.92,3.92,0,0,0-2.77,3.61l-1.65,47.64a207.44,207.44,0,0,0-51.9,42.87l-47.12-7.41a3.94,3.94,0,0,0-4.07,2l-26.82,50.54a3.91,3.91,0,0,0,.59,4.51l32.54,34.88a207.88,207.88,0,0,0-6.43,67l-38.53,28.06a3.91,3.91,0,0,0-1.44,4.31l16.77,54.7a3.92,3.92,0,0,0,3.61,2.77l47.64,1.66a207.39,207.39,0,0,0,42.87,51.89l-7.41,47.12a3.92,3.92,0,0,0,2,4.07Z",
    transform: "translate(-468.08 -455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1841.59,1986.41c-.58-.12-1.15-.25-1.73-.4a61.23,61.23,0,1,1,1.73.4ZM1863,1887.1a40.22,40.22,0,0,0-18.06,78.37,39.55,39.55,0,0,0,30.43-4.66h0a40.2,40.2,0,0,0-12.37-73.7Z",
    transform: "translate(-468.08 -455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1865.45,2068.05a5.27,5.27,0,0,1-4.15-4.72,5.11,5.11,0,0,1,.1-1.56,5.29,5.29,0,0,1,4.72-4.16,133.89,133.89,0,0,0,27.76-5.39l1.23-.38a131.85,131.85,0,0,0,74.58-59.72c.38-.65.74-1.29,1.11-1.95.49-.87,1-1.75,1.44-2.63a133.62,133.62,0,0,0,12.62-34.46A132.78,132.78,0,1,0,1766,2023.89a5.29,5.29,0,0,1-7,8l-.13-.12a143.39,143.39,0,0,1,54-243.48c75.57-23.14,155.9,19.48,179,95a143.35,143.35,0,0,1-95,179.06l-1.44.43a143.38,143.38,0,0,1-28.52,5.38A5.1,5.1,0,0,1,1865.45,2068.05Z",
    transform: "translate(-468.08 -455)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M1273.25,1635.49a8.42,8.42,0,0,1-7.74-5.08c-1.87-4.32-3.6-8.69-5.17-13a8.43,8.43,0,0,1,15.84-5.76c1.46,4,3.07,8.06,4.81,12.06a8.43,8.43,0,0,1-4.39,11.09,8.55,8.55,0,0,1-3.35.69Z",
    transform: "translate(-468.08 -455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1257.19,1580.26a8.44,8.44,0,0,1-8.32-7.11,242.15,242.15,0,0,1-2.67-25.2c0-.93-.09-1.88-.13-2.82a8.43,8.43,0,0,1,16.85-.68c0,.86.07,1.73.12,2.59a227.78,227.78,0,0,0,2.48,23.46,8.42,8.42,0,0,1-7,9.65h0A8.42,8.42,0,0,1,1257.19,1580.26Zm-.38-71.07a7.44,7.44,0,0,1-1.25-.1,8.43,8.43,0,0,1-7.1-9.57,240,240,0,0,1,5.79-27.58,8.43,8.43,0,1,1,16.27,4.43,221.64,221.64,0,0,0-5.38,25.62,8.43,8.43,0,0,1-8.33,7.2Zm21.18-67.85a8.3,8.3,0,0,1-3.72-.87,8.43,8.43,0,0,1-3.84-11.28,240.19,240.19,0,0,1,13.9-24.49,8.43,8.43,0,0,1,14.16,9.17,223,223,0,0,0-12.93,22.77,8.43,8.43,0,0,1-7.56,4.7Zm40.79-58.2a8.44,8.44,0,0,1-6.08-14.27,240.82,240.82,0,0,1,20.63-19.14,8.43,8.43,0,1,1,11,12.77l-.28.23a222.79,222.79,0,0,0-19.19,17.8,8.4,8.4,0,0,1-6.09,2.61Zm56.46-43.17a8.44,8.44,0,0,1-4-15.84,241.48,241.48,0,0,1,25.48-12,8.43,8.43,0,1,1,6.27,15.66,225,225,0,0,0-23.68,11.14,8.28,8.28,0,0,1-4.07,1.07Zm164.66-21.83a8.42,8.42,0,0,1-2-.24,224.88,224.88,0,0,0-25.77-4.56,8.43,8.43,0,1,1,1.95-16.75,239.3,239.3,0,0,1,27.74,4.91,8.44,8.44,0,0,1-2,16.64Zm-97.79-2.14a8.43,8.43,0,0,1-1.57-16.71,242.41,242.41,0,0,1,27.89-3.67,8.43,8.43,0,1,1,1.23,16.82,225,225,0,0,0-26,3.41,8.06,8.06,0,0,1-1.55.15Z",
    transform: "translate(-468.08 -455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1593.86,1338.45a8.39,8.39,0,0,1-3.92-1c-3.82-2-7.74-3.93-11.66-5.72a8.44,8.44,0,1,1,7-15.35c4.23,1.92,8.45,4,12.55,6.16a8.43,8.43,0,0,1-3.94,15.89Z",
    transform: "translate(-468.08 -455)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M1709.64,1482.81a8.43,8.43,0,0,1-8.14-6.23c-1.12-4.18-2.39-8.36-3.75-12.43a8.44,8.44,0,0,1,16-5.36c1.47,4.39,2.83,8.89,4,13.39a8.43,8.43,0,0,1-5.93,10.33h0A8,8,0,0,1,1709.64,1482.81Z",
    transform: "translate(-468.08 -455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1490.32,1775.21a8.43,8.43,0,0,1-.16-16.86q3.87-.07,7.77-.28c6-.32,12-.89,17.92-1.68a8.43,8.43,0,0,1,2.23,16.71c-6.35.85-12.83,1.46-19.25,1.8-2.79.15-5.58.25-8.35.31Zm-43.26-3.21a8.42,8.42,0,0,1-1.42-.12,239.91,239.91,0,0,1-27-6.21,8.43,8.43,0,0,1,4.44-16.27l.29.09a221.81,221.81,0,0,0,25.09,5.77,8.43,8.43,0,0,1-1.4,16.74Zm112.18-8.57a8.43,8.43,0,0,1-2.67-16.43,221,221,0,0,0,23.92-9.53,8.43,8.43,0,0,1,7.44,15.13l-.3.14A237.68,237.68,0,0,1,1561.9,1763,8.32,8.32,0,0,1,1559.24,1763.43Zm62.23-31.88a8.43,8.43,0,0,1-5-15.26,225.87,225.87,0,0,0,20-16.25,8.43,8.43,0,1,1,11.37,12.45A242.86,242.86,0,0,1,1626.4,1730,8.43,8.43,0,0,1,1621.47,1731.55Zm49.88-49a8.42,8.42,0,0,1-6.74-13.49,224.17,224.17,0,0,0,14.26-21.45,8.43,8.43,0,0,1,14.55,8.51,242.61,242.61,0,0,1-15.32,23.06,8.43,8.43,0,0,1-6.75,3.39Zm33.08-61.59a8.45,8.45,0,0,1-8.43-8.45,8.65,8.65,0,0,1,.49-2.81,224,224,0,0,0,7.19-24.73,8.43,8.43,0,0,1,16.44,3.76,241.78,241.78,0,0,1-7.74,26.62,8.45,8.45,0,0,1-8,5.65Zm13.12-68.68h-.32a8.42,8.42,0,0,1-8.11-8.72v0q.15-4.1.15-8.24c0-4-.11-8.09-.32-12.14-.1-1.78-.22-3.58-.36-5.37a8.43,8.43,0,0,1,16.81-1.31c.15,1.92.28,3.84.38,5.78.23,4.35.35,8.74.35,13,0,3-.06,5.92-.16,8.87a8.44,8.44,0,0,1-8.42,8.17Z",
    transform: "translate(-468.08 -455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M1380.54,1749.9a8.42,8.42,0,0,1-3.84-.92c-4.14-2.12-8.26-4.39-12.24-6.73a8.43,8.43,0,1,1,8.39-14.62l.16.09c3.7,2.17,7.53,4.28,11.38,6.25a8.43,8.43,0,0,1-3.85,15.93Z",
    transform: "translate(-468.08 -455)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1377.28,1676.06a2.78,2.78,0,0,0,3.2.46l30.1-15.47a147.72,147.72,0,0,0,44.51,17.34l11.72,31.73a2.79,2.79,0,0,0,2.66,1.82l40.59-.88a2.77,2.77,0,0,0,2.59-1.93l10.34-32.21a147.53,147.53,0,0,0,43.72-19.24l30.74,14.16a2.77,2.77,0,0,0,3.17-.6l28.08-29.32a2.79,2.79,0,0,0,.47-3.2l-15.48-30.1a147.72,147.72,0,0,0,17.34-44.51l31.73-11.71a2.81,2.81,0,0,0,1.82-2.67l-.88-40.59a2.77,2.77,0,0,0-1.93-2.59l-32.21-10.33a147.21,147.21,0,0,0-19.24-43.73l14.16-30.74a2.77,2.77,0,0,0-.6-3.17l-29.32-28.08a2.79,2.79,0,0,0-3.2-.47l-30.1,15.48a147.46,147.46,0,0,0-44.51-17.34L1505,1356.44a2.79,2.79,0,0,0-2.67-1.82l-40.59.88a2.77,2.77,0,0,0-2.59,1.93l-10.33,32.21a147.27,147.27,0,0,0-43.72,19.24l-30.75-14.16a2.77,2.77,0,0,0-3.17.6l-28.08,29.32a2.78,2.78,0,0,0-.46,3.2l15.47,30.1a147.44,147.44,0,0,0-17.33,44.51L1309,1514.16a2.78,2.78,0,0,0-1.81,2.67l.87,40.59A2.77,2.77,0,0,0,1310,1560l32.21,10.33a147.21,147.21,0,0,0,19.24,43.73l-14.16,30.74a2.77,2.77,0,0,0,.6,3.17Z",
    transform: "translate(-468.08 -455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1475,1584.07a52,52,0,1,1,24.68-.74h0A51.66,51.66,0,0,1,1475,1584.07Zm20.47-16Zm-5.34-54.49a20.19,20.19,0,1,0,1.12,39.2h0a20.19,20.19,0,0,0-1.12-39.2Z",
    transform: "translate(-468.08 -455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1466.68,1634a5.3,5.3,0,0,1-4.08-6.17v-.12a5.28,5.28,0,0,1,6.17-4.07,93.36,93.36,0,0,0,19.67,1.66h.48a92.79,92.79,0,0,0,90.18-91v-3.66A92.68,92.68,0,1,0,1408,1581.9a5.31,5.31,0,1,1-9,5.64,103.28,103.28,0,1,1,89.68,48.3h-1.85a103.38,103.38,0,0,1-18.83-1.64h-.16l-1.06-.19Z",
    transform: "translate(-468.08 -455)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 1259,
    cy: 311.12,
    r: 280.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 1259,
    cy: 311.12,
    r: 271.49
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1476.81,755.69h-.15a2.88,2.88,0,0,1-2.71-3,252,252,0,0,1,3.68-31.83,2.86,2.86,0,0,1,5.64,1,250.23,250.23,0,0,0-3.6,31.12A2.86,2.86,0,0,1,1476.81,755.69Z",
    transform: "translate(-468.08 -455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1503.21,656.21a2.86,2.86,0,0,1-2.56-4.16c43.41-86,130.17-139.41,226.43-139.41a255,255,0,0,1,45.72,4.12,2.87,2.87,0,0,1-.63,5.7,2.2,2.2,0,0,1-.37-.06,250,250,0,0,0-44.7-4c-94.08,0-178.88,52.21-221.31,136.26A2.84,2.84,0,0,1,1503.21,656.21Z",
    transform: "translate(-468.08 -455)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 1732.99,
    cy: 772.05,
    r: 229.78,
    transform: "translate(-506.42 996.54) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1800.35,681.19c0,40.25-32.63,83.7-72.88,83.7s-72.89-43.45-72.89-83.7,32.63-68.81,72.89-68.81S1800.35,640.93,1800.35,681.19Z",
    transform: "translate(-468.08 -455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1637,919.87h177.92a43,43,0,0,0,41-30L1865.5,860a43,43,0,0,0-26-53.53c-72.41-26.47-147.28-23.08-224,2.44C1594,816,1582.09,839,1588,860.86l7.37,27.18A43.08,43.08,0,0,0,1637,919.87Z",
    transform: "translate(-468.08 -455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M1359.49,3231.52a9.12,9.12,0,0,1-9.12-9.12h0V2132.25a9.12,9.12,0,0,1,18.24,0V3222.4a9.12,9.12,0,0,1-9.12,9.12Z",
    transform: "translate(-468.08 -455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M1112.33,3231.52a9.12,9.12,0,0,1-9.12-9.12h0V2132.25a9.12,9.12,0,0,1,18.24,0V3222.4a9.12,9.12,0,0,1-9.12,9.12Z",
    transform: "translate(-468.08 -455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M505.1,3238.44a9.14,9.14,0,0,1-9.12-9.14,9,9,0,0,1,.73-3.56L963.1,2128.68a9.12,9.12,0,1,1,16.79,7.14L513.5,3232.88A9.13,9.13,0,0,1,505.1,3238.44Z",
    transform: "translate(-468.08 -455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M793.19,3238.44a9.14,9.14,0,0,1-9.12-9.14,9,9,0,0,1,.73-3.56l466.38-1097.06a9.12,9.12,0,1,1,16.79,7.14L801.58,3232.88A9.11,9.11,0,0,1,793.19,3238.44Z",
    transform: "translate(-468.08 -455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1373.65,2142.29H946.43a12.86,12.86,0,0,1-12.86-12.86h0a12.85,12.85,0,0,1,12.85-12.85h427.23a12.85,12.85,0,0,1,12.85,12.85h0a12.85,12.85,0,0,1-12.84,12.86Z",
    transform: "translate(-468.08 -455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1189.12,2309.12H900.18a9.12,9.12,0,0,1,0-18.24h288.94a9.12,9.12,0,0,1,0,18.24Z",
    transform: "translate(-468.08 -455)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 343.45,
    y: 2043.36,
    width: 288.94,
    height: 18.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 257.62,
    y: 2250.85,
    width: 288.94,
    height: 18.24
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M924.63,2931.57H635.69a9.12,9.12,0,1,1,0-18.24h289a9.12,9.12,0,0,1,0,18.24Z",
    transform: "translate(-468.08 -455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M837.61,3139.05H548.68a9.12,9.12,0,1,1,0-18.24h289a9.12,9.12,0,0,1,0,18.24Z",
    transform: "translate(-468.08 -455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M1008.18,2038.91s-11.85,16.74-17.07,65a7.89,7.89,0,0,0,7,8.71l.44,0,85.84,4.36a5.07,5.07,0,0,0,5.33-4.8,5,5,0,0,0-.18-1.62c-4.27-15.14-17.64-52.21-50.52-74.67Z",
    transform: "translate(-468.08 -455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M996.54,2012.65l9.4,40a7.67,7.67,0,0,0,7.41,5.95,67.88,67.88,0,0,0,18-2.21,12.6,12.6,0,0,0,8.91-13.58l-4.41-39.1Z",
    transform: "translate(-468.08 -455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M1204.21,2041.88s-17.33,25-18.2,60.07a15.17,15.17,0,0,0,14.74,15.37l133.4,4.66a6.39,6.39,0,0,0,4.08-11.49c-24.63-18.61-73.09-53.46-108.52-67.72Z",
    transform: "translate(-468.08 -455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M1200.88,1999.29l3.42,51.28a10.38,10.38,0,0,0,11,9.76h0a37.79,37.79,0,0,0,12.3-3.26,11.93,11.93,0,0,0,6.93-11.33l-2.32-61.88Z",
    transform: "translate(-468.08 -455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M935.3,1322.82s-32.27,35.63-34.73,74.39,93,653.48,93,653.48,36.5,1.92,53.7-11.36c0,0-23.29-403.3-17.08-497.8,0,0,134.12,405.37,166.77,477.66,0,0,35,.31,45.38-7.51,0,0-83.56-535.66-123.09-628.11Z",
    transform: "translate(-468.08 -455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M1027.27,1530a5.23,5.23,0,0,1-4.88-3.35l-21.07-54.75-33.42-16.48a5.22,5.22,0,0,1,4.62-9.37h0l35.26,17.38a5.22,5.22,0,0,1,2.56,2.81l21.8,56.66a5.21,5.21,0,0,1-3,6.74h0A5.21,5.21,0,0,1,1027.27,1530Z",
    transform: "translate(-468.08 -455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M1248.6,926.08c-152.23,4.49-188.13,40.14-188.13,40.14l85.38,106.25s147.86-19.64,244.81-113.45c-22.28-19.16-38.75-41.26-49.68-58.68A201.32,201.32,0,0,1,1248.6,926.08Z",
    transform: "translate(-468.08 -455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M1459.81,678.08a4.66,4.66,0,0,0-9-.77l-14.61,43.23a43.07,43.07,0,0,0-.54,25.84l9.44,23.14a41.51,41.51,0,0,1-4.71,33.78c-15.19,24.1-48.3,68.72-99.4,97,10.93,17.42,27.4,39.52,49.68,58.68C1426.24,924.6,1455,880.2,1467,823.11a20.32,20.32,0,0,0,12-21.67Z",
    transform: "translate(-468.08 -455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M1305.72,986.82c-59.54-51.22-163.59-65.67-223.33-69.68A54,54,0,0,0,1026.2,958c-18.36,73.8-69.25,266.15-79.57,299.39-8.46,27.27-17.5,54-23.27,70.71a19.16,19.16,0,0,0,11.75,24.37c51.94,18.19,143.61,35.06,180.72,41.49a12.41,12.41,0,0,0,14.34-10.12,12.58,12.58,0,0,0,.1-3.52,38.72,38.72,0,0,1,3.26-20.44l110.52-242.14c95.44,84.49,170.69,84.71,225.44,57.69a431.59,431.59,0,0,1-28.94-87C1354.62,1083.45,1305.72,986.82,1305.72,986.82Z",
    transform: "translate(-468.08 -455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M1578.12,1056.89l-17.5-18.57c-45.44,39.38-85.71,52-120.07,50.07a431.59,431.59,0,0,0,28.94,87C1541.61,1139.79,1578.12,1056.89,1578.12,1056.89Z",
    transform: "translate(-468.08 -455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M1567.43,1058.47l86.1-6.32,73.94-53c-12.12-5.82-74.55,15.91-74.55,15.91s-68.11-2.57-86.24-.55c-15,1.67-10.46,23.08-8.47,30.28.4,1.47.7,2.35.7,2.35Z",
    transform: "translate(-468.08 -455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M1151.07,803l-32.78,115.46s56,30.11,97.44,22l11.38-101.78Z",
    transform: "translate(-468.08 -455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M1219,719.14c1.2,1.35,45.78,112.24,45.78,112.24l-63.85,24.11-57.87-98.82S1198.88,696.53,1219,719.14Z",
    transform: "translate(-468.08 -455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M1169.58,769.69l26.4,54.4a8,8,0,0,0,1.27,1.91c3.15,3.55,14.88,15,25.83,2.26,9.94-11.54,19.19-21.92,28.49-24.67a8.45,8.45,0,0,1,10.23,4.95c4,10.08,12.75,33,17.28,54a8.42,8.42,0,0,1-5.79,9.79c-12.56,3.88-39.29,11.34-62.2,12.3a8.44,8.44,0,0,1-7.62-4.08c-7.81-13-31.68-52.34-40-62.28-7.83-9.32-24.22-7.19-31-5.8a8.24,8.24,0,0,1-6.41-1.33c-6.62-4.6-19.61-16.79-5.3-34.75a8.46,8.46,0,0,0-1.32-11.89l-.24-.19c-7.66-5.73-16.37-16.45-6.44-32.07,10.08-15.89,25.83-15.32,35.71-12.92a8.46,8.46,0,0,0,9.68-4.88c1-2.13,2.87-3.88,6.49-4a8.3,8.3,0,0,0,7.93-8.67,7.2,7.2,0,0,0-.07-.8c-1.21-9.31.8-21.48,16.41-28.34,27.71-12.17,48.75,13.55,52.85,34s-26.68,32-45.47,32.7c-14.29.54-23.22,15.76-26.68,23A8.37,8.37,0,0,0,1169.58,769.69Z",
    transform: "translate(-468.08 -455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M1173.25,838s-8.69-35.42-23.84-35.49-28.31,13.85-11.18,32.34C1159.55,857.83,1173.25,838,1173.25,838Z",
    transform: "translate(-468.08 -455)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskB);
export default __webpack_public_path__ + "static/media/task-b.d805614ea3204a1ed65b9ba426bdb38e.svg";
export { ForwardRef as ReactComponent };